import { useState, useEffect } from 'react';
import blow from "../assets/image/bolwing-arrow.png";
import rocket from "../assets/image/rocket.png";
import money from "../assets/image/money.png";
import ArrowBg from "../component/ArrowBg";
import { useNavigate } from 'react-router-dom';
import ArrowBgBottom from '../component/ArrowBgBottom';


export default function CTA(){
  const navigate = useNavigate()
    return(
        <section
  id="home"
  className="
    w-full 
                  bg-black
                  rounded-tl-[60px] rounded-tr-[60px] md:rounded-tl-[60px] md:rounded-tr-[60px]
                  overflow-hidden relative  
  "
>
  <div className="
    w-full 
                  bg-emerald-700
                  rounded-bl-[60px] rounded-br-[60px]
                  overflow-hidden relative
                 
        
                  /* Mobile */
                  pl-0 sm: pr-0
        
                  sm:pl-[1px] sm:pr-[1px] sm: pt-[120px] sm: pb-[110px]
        
                  /* Medium (md) */
                  md:pr-[28px] md:pl-[30px] md:pt-[150px] md:pb-[100px]
        
                  /* Large (lg) */
                  lg:pt-[140px] lg:pb-[100px] lg:pr-[40px] lg:pl-[40px] lg:rounded-bl-[60px] lg:rounded-br-[60px]
    flex items-center justify-center   /* CENTER EVERYTHING */
  "
  style={{
    background:
      "radial-gradient(ellipse at top center, #149D64 0%, #0B6351 100%)",
  }} >
  {/* MAIN CONTENT CENTERED */}
  <div
    className="
      max-w-[1280px] w-full
      
      text-center
      flex flex-col items-center justify-center
      relative z-10
      px-6
    "
  >
    {/* HEADING */}
    <div className='  max-w-[390px]  md:max-w-[670px]'>
      <h1
        className="
          font-inter font-normal text-white tracking-[-1.44px] leading-[38.6px] md:leading-[44.6px] lg:leading-[57.6px]
          text-[30px]
          sm:text-[32px]
          md:text-[36px]
          lg:text-[43.5px]
        "
      >
        Check your eligibility now & get a call back within a few hours
      </h1>

      
    </div>

    {/* PARAGRAPH */}
    <p
      className="
        font-inter font-normal text-white mb-10 mt-4
       max-w-[420px] md:max-w-[670px]
        text-[15px] sm:text-[15px] md:text-[16px] lg:text-[17px]
        leading-[22px] sm:leading-[24px] md:leading-[26px] lg:leading-[28px]
     
      "
    >
      Find out if you qualify in just a few steps. No delays. No paperwork hassles. Just fast answers and flexible loan options made for your business
    </p>

    {/* BUTTON */}
    <button
      className="
        relative
        text-[18px] md:text-[20px] font-semibold text-white
        rounded-[18px]
        w-fit h-fit
        px-8 py-4
        bg-black
        button-default
        
        hover:text-[#2a9d72]
        transition-all duration-300
        cursor-pointer
        z-20
        
      "
      onClick={()=>navigate('/contact')}
    >
      Start Your Process
    </button>
  </div>

           {/* Decorative Elements (keep absolute) */}
                <ArrowBgBottom className="absolute  " />

                  {/* Top-left glowing arrow */}
                                
        
                {/* Bottom-left rocket*/}
                <img 
                  src={rocket} 
                  alt="" 
                  className="absolute object-contain opacity-100
                    bottom-1/2 -left-7 w-32 h-32
                    sm: bottom-[44%] sm: -left-[6%] sm:w-32 sm:h-32 sm: rotate-[10deg]
                    md:bottom-28 md:-left-16 md:w-44 md:h-44 md:rotate-[10deg]
                    lg:bottom-40 lg:-left-20 lg:w-56 lg:h-56
                  "
                  style={{'--rotate': '10deg'}}
                />
        
                {/* Bottom-right money icon */}
               {/* <img 
                  src={money} 
                  alt="" 
                  className="absolute opacity-100 blur-[2px] rotate-[335deg] object-contain w-full h-full max-w-[218px] max-h-[128px] 
                    -bottom-[6%] right-[0px]
                    sm:right-[0px] 
                    md:right-[0px] 
                    lg:right-[210px]
                   
                  "
                  style={{'--rotate': '335deg'}}
                />*/}
        
                {/* Mid-right big diagonal shape */}
                <img 
                  src={money} 
                  alt=""
                  className="absolute  blur-[2px]  object-contain w-28 h-28 sm:w-28 sm:h-28 md:w-28 md:h-28 lg:w-44 lg:h-44  max-w-[232px] max-h-[232px] -rotate-[25deg]
                    bottom-40 -right-[10%] 
                    sm:-right-[8%]
                    md:-right-[5%] 
                    lg:-right-[6%]
                  "
                />
        
                {/* Bottom-left money icon */}
                <img 
                  src={money} 
                  alt="" 
                  className="absolute rotate-[13deg] object-contain w-44 h-44 sm:w-44 sm:h-44 md:w-44 md:h-44 lg:w-full lg:h-full max-w-[248px] max-h-[248px]
                    -top-[12%] right-[50%]
                    sm:-top-[10%]
                    md:-top-[14%]
                    lg:-top-[18%]
                  " 
                  style={{'--rotate': '13deg'}}
                />
                </div>
</section>

    )
}